module.exports = __webpack_public_path__ + "img/product.9e88db59.svg";